import { render, staticRenderFns } from "./ModalHapus.vue?vue&type=template&id=3a33d7c2"
import script from "./ModalHapus.vue?vue&type=script&lang=js"
export * from "./ModalHapus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports